import React from 'react';
import styled from 'styled-components';

export default ({ heading, children }) => (
    <GridContainer>
        <Heading>{heading}</Heading>
        {children}
    </GridContainer>
);

const GridContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom:3rem;
`;

const Heading = styled.h2`
    width: 100%;
    font-weight: bold;
    margin-bottom: 2rem;
`;
